module.exports = __webpack_public_path__ + "img/product_10.cfd4483.webp";